export default __webpack_public_path__ + "static/media/img_03.9cc1f77d.jpg";